"use client"

import Link from "next/link"
import styles from "./breadcrumb.module.scss"
import StyledText from "../typography/typography-component"
import skColors from "../../styles/skColors"
import classNames from "classnames"
import { RatgeberArticlePage, RatgeberArticlePageWithLocalImage, RatgeberCategoryPage } from "./_types"
import { Routes, useTypedRouter } from "../data/routes"

interface BreadcrumbProps {
  page: RatgeberArticlePage | RatgeberCategoryPage | RatgeberArticlePageWithLocalImage
  className?: string
}

const Breadcrumb: React.FC<BreadcrumbProps> = ({ page, className }) => {
  const parentCategory = "category_page" in page ? page.category_page : undefined
  const router = useTypedRouter()

  return (
    <nav className={classNames(styles.breadcrumb, className)}>
      <StyledText color={skColors.darkgreen[500]} variant={"tags"}>
        <Link href={Routes.ratgeber}>Ratgeber</Link>
        {` / `}
      </StyledText>
      {parentCategory && (
        <StyledText color={skColors.darkgreen[500]} variant={"tags"}>
          <Link href={`/ratgeber/${parentCategory?.slug}`}>{parentCategory?.title}</Link>
          {` / `}
        </StyledText>
      )}
      <StyledText color={skColors.darkgreen[500]} variant={"tags"}>
        {page?.title}
      </StyledText>
    </nav>
  )
}

export default Breadcrumb
